import { PrimitiveType } from "@buildwithflux/models";
/**
 * Determines if a primitive is convex or not
 */
export function isConvex(primitive) {
    if (primitive.type === PrimitiveType.ApproxPolygon) {
        return primitive.convex;
    }
    if (primitive.type === PrimitiveType.Expansion) {
        // An expansion shape is convex if the underlying shape is convex
        return isConvex(primitive.primitive);
    }
    if (primitive.type === PrimitiveType.LineArc) {
        // An arc is typically concave
        return false;
    }
    if (primitive.type === PrimitiveType.Union || primitive.type === PrimitiveType.Difference) {
        // Not supported for now, assume not convex
        return false;
    }
    // All other default shapes (circle, oblong, rectangle) are convex
    return true;
}
//# sourceMappingURL=isConvex.js.map